import { render, staticRenderFns } from "./Materia Prima.vue?vue&type=template&id=343a3efe&scoped=true&lang=pug&"
var script = {}
import style0 from "./Materia Prima.vue?vue&type=style&index=0&id=343a3efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a3efe",
  null
  
)

export default component.exports